import PropTypes from 'prop-types'
import { QueryErrorResetBoundary } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'

import CaughtError from './CaughtError'
import NotLoggedLayout from '../../ui/layout/NotLoggedLayout'

const IrrecoverableCaughtError = ({ error, resetErrorBoundary }) => (
  <NotLoggedLayout>
    <CaughtError error={error} resetErrorBoundary={resetErrorBoundary} />
  </NotLoggedLayout>
)

IrrecoverableCaughtError.propTypes = {
  error: PropTypes.any,
  resetErrorBoundary: PropTypes.func.isRequired,
}

const ErrorCrashBoundary = ({ children, ...rest }) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary
        FallbackComponent={IrrecoverableCaughtError}
        onReset={reset}
        onError={(error, info) => {
          // TODO: Log to Sentry?
        }}
        {...rest}
      >
        {children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
)

ErrorCrashBoundary.propTypes = {
  children: PropTypes.node,
}

export default ErrorCrashBoundary
